<template class="bap">
    <v-simple-table >
        <template v-slot:default>
        <thead>
            <tr>
            <th class="text-left">
                &nbsp;
            </th>
            <th class="text-right" style="font-size:16px;font-weight:100;color:black;">
                Bail 3/6/9
            </th>
            <th class="text-right" style="font-size:16px;font-weight:100;color:black;">
                Bureau opéré
            </th>
            <th class="text-right" style="font-size:16px;font-weight:100;color:black;">
                Coworking
            </th>
            </tr>
        </thead>
        <tbody>
            <tr
            v-for="l, index in lignes"
            :key="l[0]"
            >
            <template v-if="l[1] === 'prix_unitaire'">
                <td class="text-left"><span style="font-size:16px;font-style:italic;">{{ l[0] }}</span></td>
                <td class="text-right"><span style="font-size:14px;font-style:italic;">{{ fmtNumber(loyer_annuel369) }} / m² / an</span></td>
                <td class="text-right"><span style="font-size:14px;font-style:italic;">{{ fmtNumber(loyer_annuelService) }} / poste / mois</span></td>
                <td class="text-right"><span style="font-size:14px;font-style:italic;">{{ fmtNumber(loyer_annuelCoworking) }} / poste / mois</span></td>
            </template>
            <template v-else-if="lignes_st.includes(index)">
                <td class="grey lighten-2"><span style="font-size:16px;">{{ l[0] }}</span></td>
                <td class="grey lighten-2 text-right"><span style="font-size:16px;">{{ fmtNumber(getFunction(l[1], 1, 'Bail369')) }}</span></td>
                <td class="grey lighten-2 text-right"><span style="font-size:16px;">{{ fmtNumber(getFunction(l[1], 1, 'BureauOpere')) }}</span></td>
                <td class="grey lighten-2 text-right"><span style="font-size:16px;">{{ fmtNumber(getFunction(l[1], 1, 'Coworking')) }}</span></td>
            </template>
            <template v-else-if="lignes_total.includes(index)">
                <td class="text-left" style="background-color:#3C46DC;"><strong style="font-size:16px;color:white;letter-spacing:0.8px">{{ l[0] }}</strong></td>
                <td class="text-right" style="background-color:#3C46DC;"><strong style="font-size:16px;color:white;letter-spacing:0.8px">{{ fmtNumber(getFunction(l[1], 1, 'Bail369')) }}</strong></td>
                <td class="text-right" style="background-color:#3C46DC;"><strong style="font-size:16px;color:white;letter-spacing:0.8px">{{ fmtNumber(getFunction(l[1], 1, 'BureauOpere')) }}</strong></td>
                <td class="text-right" style="background-color:#3C46DC;"><strong style="font-size:16px;color:white;letter-spacing:0.8px">{{ fmtNumber(getFunction(l[1], 1, 'Coworking')) }}</strong></td>
            </template>
            <template v-else>
                <td class="text-left"><span style="font-size:16px;">{{ l[0] }}</span></td>
                <td class="text-right"><span style="font-size:16px;">{{ fmtNumber(getFunction(l[1], 1, 'Bail369')) }}</span></td>
                <td class="text-right"><span style="font-size:16px;">{{ fmtNumber(getFunction(l[1], 1, 'BureauOpere')) }}</span></td>
                <td class="text-right"><span style="font-size:16px;">{{ fmtNumber(getFunction(l[1], 1, 'Coworking')) }}</span></td>
            </template>
            </tr>
        </tbody>
        </template>
    </v-simple-table>
</template>

<style lang="scss">
@font-face {
  font-family: "RoobertRegular";
  src: local("RoobertRegular"),
   url('../assets/Roobert-Regular.woff') format("woff");
}
@font-face {
  font-family: "RoobertSemiBold";
  src: local("RoobertSemiBold"),
   url('../assets/Roobert-SemiBold.woff') format("woff");
}
$font-family-regular: 'RoobertRegular';
$font-family-bold: 'RoobertSemiBold';
$body-font-family: 'Roobert' !important;

.bap {
  [class*='template-'],
  [class*='table-'],
  [class*='td-'],
  [class*='v-data'],
  [class*='v-application'],
  [class*='subtitle'],
  [class*='text'] {
    font-family: $font-family-regular !important;
  }
  font-family: $font-family-regular !important;
}
</style>

<script>
import store from '../store'

export default {
  name: 'FirstYearDetail',
  store,
  props: [
      'loyer_annuel369',
      'loyer_annuelService',
      'loyer_annuelCoworking',
      'surface_recherchee',
      'duree',
      'depot_garantie369',
      'depot_garantieService',
      'depot_garantieCoworking',
      'frais_agence',
      'franchise_loyer369',
      'franchise_loyerService',
      'franchise_loyerCoworking',
      'nombre_postes',
      'charges_locatives_index',
      'taxes_foncieres_index',
      'frais_gestion_rate',
      'm2_par_poste',
    ],
  data: () => ({
    lignes: [
        ['Total général', 'total_general'],
        ['Prix unitaire', 'prix_unitaire'],
        ['Loyer HT HC', 'loyer_annuel_ht_hc'],
        ['Loyer', 'loyer'],
        ['Franchise', 'franchise'],
        ['Charges, Taxes, Impôts', 'total_charges_taxes'],
        ['Charges locatives', 'charges_locatives'],
        ['Taxe foncière, taxe sur les bureaux, voirie', 'taxes_foncieres'],
        ['Frais de gestion', 'frais_gestion'],
        ['Charges privatives', 'total_charges_privatives'],
        ['Electricité / CPCU / Eau / Fraîcheur de Paris', 'electricite_chauffage_eau'],
        ['Ménage', 'menage' ],
        ['Internet + maintenance réseau', 'internet'],
        ['Consommables (fontaines à eau, café...)', 'consommables'],
        ['Accès (badgeuses, SSI...)', 'acces'],
        ['Tri Sélectif', 'tri_selectif'],
        ['Assurance multirisque bureaux', 'assurance'],
        ['Maintenance, Entretien et Matériel', 'maintenance'],
        ['Office management', 'total_office_management'],
        ['Office management ', 'office_management'],
        ['CAPEX Aménagement', 'total_capex_amenagement'],
        ['Travaux', 'travaux'],
        ['Aménagement et mobilier', 'amenagement_mobilier'],
        ['Frais d\'emménagement et de déménagement', 'total_frais_emmenagement'],
        ['Dépôt de garantie', 'depot_garantie_tab'],
        ['Honoraires broker', 'honoraires'],
        ['Frais juridiques', 'frais_juridique'],
        ['Frais de remise en état', 'frais_remise_etat'],
      ],
      lignes_st: [2, 5, 9, 18, 20, 23],
      lignes_total: [0],
  }),
  methods: {
    fmtNumber: function (number) {
        if (isNaN(number)) {
            return "-"
        }
        if (typeof number == 'number') {
            return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }).format(Math.round(number))
        } else if (number == 'inclus') {
            return 'inclus'
        } else if (number == 'gratuit avec ubiq') {
            return 'gratuit avec ubiq'
        } else if (number == 'gratuit') {
            return 'inclus'
        }
    },
    getFunction: function(ligne, year, type) {
        // console.log("this."+ligne+"(year="+year+", type='"+type+"')")
        return eval("this."+ligne+"(year="+year+", type='"+type+"')")
    },
    loyer_annuel_ht_hc: function (year, type) {
        let result = 0
        result = this.loyer(year, type)
        if (typeof this.franchise(year, type) === 'number') {
            result = result + this.franchise(year, type)
        }
        return Math.round(result)
    },
    loyer: function (year, type) {
        let result = 0
        if (type === "Bail369") {
            result = this.duree * this.surface_recherchee * this.loyer_annuel369
        } else if (type === "BureauOpere") {
            let nombre_postes = this.surface_recherchee / this.m2_par_poste
            result = 12 * this.duree * nombre_postes * this.loyer_annuelService
        } else if (type === "Coworking") {
            let nombre_postes = this.surface_recherchee / this.m2_par_poste
            result = 12 * this.duree * nombre_postes * this.loyer_annuelCoworking
        }
        return result
    },
    franchise: function (year, type) {
        let result = 0
        if (type === "Bail369") {
            if (this.franchise_loyer369 > 0) {
                result = (this.loyer_annuel369 * this.surface_recherchee / 12) * this.franchise_loyer369 * this.duree
            }
        } else if (type === "BureauOpere") {
            if (this.franchise_loyerService > 0) {
                result = (this.loyer_annuelService * this.surface_recherchee / 12) * this.franchise_loyerService
            }
        } else if (type === "Coworking") {
            if (this.franchise_loyerCoworking > 0) {
                result = (this.loyer_annuelCoworking * this.surface_recherchee / 12) * this.franchise_loyerCoworking
            }
        }
        if (result > 0) {
            return -Math.round(result)
        }
        return '-'
    },
    charges_locatives: function (year, type) {
        if (type === "Bail369") {
            return this.charges_locatives_index * this.surface_recherchee * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    taxes_foncieres: function (year, type) {
        if (type === "Bail369") {
            return this.taxes_foncieres_index * this.surface_recherchee * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    frais_gestion: function (year, type) {
        if (type === "Bail369") {
            return this.loyer(year, type) * this.frais_gestion_rate
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    total_charges_taxes: function (year, type) {
        if (type === "Bail369") {
            return this.charges_locatives(year, type) + this.taxes_foncieres(year, type) + this.frais_gestion(year, type)
        } else if (type === "BureauOpere") {
            return 0
        } else if (type === "Coworking") {
            return 0
        }
    },
    electricite_chauffage_eau: function (year, type) {
        if (type === "Bail369") {
            let tarif = 0
            if (this.surface_recherchee < 200) {
                tarif = 35
            } else if (this.surface_recherchee < 1000) {
                tarif = 31
            } else {
                tarif = 25
            }
            return tarif * this.surface_recherchee * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    menage: function (year, type) {
        if (type === "Bail369") {
            return Math.max(450 * 12, 30 * this.surface_recherchee) * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    internet: function (year, type) {
        if (type === "Bail369") {
            let tarif = 0
            if (this.surface_recherchee < 200) {
                tarif = 36
            } else if (this.surface_recherchee < 1000) {
                tarif = 25
            } else {
                tarif = 16
            }
            return tarif * this.surface_recherchee * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    assurance: function (year, type) {
        if (type === "Bail369") {
            return 2 * this.surface_recherchee * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    reparations: function (year, type) {
        if (type === "Bail369") {
            if (year < 4) {
                return Math.round(this.surface_recherchee*12)
            } else {
                return Math.round(this.surface_recherchee*12*3)
            }
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    accessoires: function (year, type) {
        if (type === "Bail369") {
            if (year < 4) {
                return Math.round(this.surface_recherchee*10)
            } else {
                return Math.round(this.surface_recherchee*10*3)
            }
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    consommables: function (year, type) {
        if (type === "Bail369") {
            let nombre_postes = this.surface_recherchee / this.m2_par_poste
            return nombre_postes * 65 * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    acces: function (year, type) {
        if (type === "Bail369") {
            return this.surface_recherchee * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    tri_selectif: function (year, type) {
        if (type === "Bail369") {
            return Math.max(1850, this.surface_recherchee * 4.5) * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    maintenance: function (year, type) {
        if (type === "Bail369") {
            let tarif = this.surface_recherchee <= 1000 ? 14 : 22
            return Math.max(5000, tarif * this.surface_recherchee) * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    autres: function (year, type) {
        if (type === "Bail369") {
            if (year < 4) {
                return Math.round(this.surface_recherchee*20)
            } else {
                return Math.round(this.surface_recherchee*20*3)
            }
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    total_charges_privatives: function (year, type) {
        if (type === "Bail369") {
            let result = 0
            result = this.electricite_chauffage_eau(year, type) 
                + this.menage(year, type)
                + this.internet(year, type)
                + this.consommables(year, type)
                + this.acces(year, type)
                + this.tri_selectif(year, type)
                + this.assurance(year, type)
                + this.maintenance(year, type)
            return Math.round(result)
        } else if (type === "BureauOpere") {
            return 0
        } else if (type === "Coworking") {
            return 0
        }
    },
    mobilier: function (year, type) {
        if (type === "Bail369") {
            let result = 0
            if (year === 1) {
                result = this.surface_recherchee*400
            } else if (year === 4) {
                let result0 = 0
                let result1 = 0
                result0 = this.surface_recherchee*400
                result1 = this.surface_recherchee*10
                result = result0 + (result1*2)
            } else if (year > 1) {
                result = this.surface_recherchee*10
            }
            return Math.round(result)
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    total_mobilier: function (year, type) {
        if (type === "Bail369") {
            let result = 0
            result = this.mobilier(year, type) 
            return Math.round(result)
        } else if (type === "BureauOpere") {
            return 0
        } else if (type === "Coworking") {
            return 0
        }
    },
    total_office_management: function (year, type) {
        if (type === "Bail369") {
            return this.office_management(year, type)
        } else if (type === "BureauOpere") {
            return 0
        } else if (type === "Coworking") {
            return 0
        }
    },
    office_management: function (year, type) {
        if (type === "Bail369") {
            let fte = 0
            if (this.surface_recherchee < 250) {
                fte = 0
            } else if (this.surface_recherchee < 1000) {
                fte = 0.5
            } else {
                fte = 1.5
            }
            return fte * 32000 * 1.42 * this.duree
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    total_capex_amenagement: function (year, type) {
        if (type === "Bail369") {
            return this.travaux(year, type) + this.amenagement_mobilier(year, type)
        } else if (type === "BureauOpere") {
            return 0
        } else if (type === "Coworking") {
            return 0
        }
    },
    travaux: function (year, type) {
        if (type === "Bail369") {
            let tarif = 0
            if (this.surface_recherchee < 200) {
                tarif = 250
            } else if (this.surface_recherchee < 1000) {
                tarif = 350
            } else {
                tarif = 450
            }
            return tarif * this.surface_recherchee
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    amenagement_mobilier: function (year, type) {
        if (type === "Bail369") {
            let tarif = 0
            if (this.surface_recherchee < 200) {
                tarif = 150
            } else if (this.surface_recherchee < 1000) {
                tarif = 200
            } else {
                tarif = 250
            }
            return tarif * this.surface_recherchee
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    total_frais_emmenagement: function (year, type) {
        let result = 0
        if (typeof(this.depot_garantie_tab(year, type)) === 'number') {
            result = result + this.depot_garantie_tab(year, type)
        }
        if (typeof(this.honoraires(year, type)) === 'number') {
            result = result + this.honoraires(year, type) 
        }
        if (typeof(this.frais_juridique(year, type)) === 'number') {
            result = result + this.frais_juridique(year, type) 
        }
        if (typeof(this.frais_remise_etat(year, type)) === 'number') {
            result = result + this.frais_remise_etat(year, type) 
        }
        if (result !== 0){
            return Math.round(result)
        }
    },
    frais_remise_etat: function (year, type) {
        if (type === "Bail369") {
            return 150 * this.surface_recherchee
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    depot_garantie_tab: function (year, type) {
        let result = 0
        if (type === "Bail369") {
            if (year === 1) {
                result = (this.loyer(year, type) / this.duree) * 8 / 12
                return result
            } else if (year === 3) {
                result = -(this.loyer(year, type) / this.duree) * 8 / 12
                return result
            }
            return 0
        } else if (type === "BureauOpere") {
            if (year === 1) {
                let nombre_postes = this.surface_recherchee / this.m2_par_poste
                result = this.loyer_annuelService * nombre_postes * 3
                return result
            } else if (year === 3) {
                let nombre_postes = this.surface_recherchee / this.m2_par_poste
                result = -this.loyer_annuelService * nombre_postes * 3
                return result
            }
        } else if (type === "Coworking") {
            if (year === 1) {
                let nombre_postes = this.surface_recherchee / this.m2_par_poste
                result = this.loyer_annuelCoworking * nombre_postes * 3
                return result
            } else if (year === 3) {
                let nombre_postes = this.surface_recherchee / this.m2_par_poste
                result = -this.loyer_annuelCoworking * nombre_postes * 3
                return result
            }
        }
    },
    honoraires: function (year, type) {
        if (type === "Bail369") {
            if ((year === 1) || (year === 4)) {
                let result = (this.loyer(year, type) / this.duree) * 0.15
                return result
            }
        } else if (type === "BureauOpere") {
            if (year === 1) {
                return 'gratuit avec ubiq'
            }
        } else if (type === "Coworking") {
            if (year === 1) {
                return 'gratuit avec ubiq'
            }
        }
    },
    frais_juridique: function (year, type) {
        if (type === "Bail369") {
            if ((year === 1) || (year === 4)) {
                if (this.surface_recherchee < 500) {
                    return 2500
                } else if (this.surface_recherchee < 1000) {
                    return 5000
                } else {
                    return 15000
                }
            }
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    frais_emmenagement: function (year, type) {
        if (type === "Bail369") {
            if ((year === 1) || (year === 4)) {
                return Math.round(this.surface_recherchee*this.loyer_annuel369*(20/100))
            }
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    frais_demenagement: function (year, type) {
        if (type === "Bail369") {
            if ((year === 3) || (year === 4)) {
                return Math.round(this.surface_recherchee*this.loyer_annuel369*(7.5/100))
            }
        } else if (type === "BureauOpere") {
            return 'inclus'
        } else if (type === "Coworking") {
            return 'inclus'
        }
    },
    total_general: function(year, type) {
        if (type === "Bail369") {
            let result = 0
            result = this.loyer_annuel_ht_hc(year, type) 
                + this.total_charges_taxes(year, type) 
                + this.total_charges_privatives(year, type) 
                + this.total_office_management(year, type)
                + this.total_capex_amenagement(year, type)
            if (typeof(this.total_frais_emmenagement(year, type)) === 'number') {
                result = result + this.total_frais_emmenagement(year, type) 
            }
            return Math.round(result)
        } else if (type === "BureauOpere" || type === "Coworking") {
            // Simple formula: loyer + depot de garantie
            let result = this.loyer(year, type)
            if (typeof(this.depot_garantie_tab(year, type)) === 'number') {
                result = result + this.depot_garantie_tab(year, type)
            }
            return Math.round(result)
        }
    },
    prix_unitaire: function (year, type) {
        if (type === 'Bail369') {
            return Math.round(this.loyer_annuel369)
        } else if (type === 'BureauOpere') {
            return Math.round(this.loyer_annuelService * 12)
        } else if (type === 'Coworking') {
            return Math.round(this.loyer_annuelCoworking * 12)
        }
    },
    updateCoutReel() {
        // Sortie de cash au premier trimestre
        let sortieCash = 0
        // loyer/duree + franchise + (total_charges_taxes + total_charges_privatives + total_office_management) / duree + total_capex_amenagement + depot_garantie_tab + honoraires + frais_juridique
        sortieCash = (this.loyer(1, 'Bail369') / this.duree)
            + (typeof this.franchise(1, 'Bail369') === 'number' ? this.franchise(1, 'Bail369') : 0)
            + (this.total_charges_taxes(1, 'Bail369') + this.total_charges_privatives(1, 'Bail369') + this.total_office_management(1, 'Bail369')) / this.duree
            + this.total_capex_amenagement(1, 'Bail369')
            + (typeof this.depot_garantie_tab(1, 'Bail369') === 'number' ? this.depot_garantie_tab(1, 'Bail369') : 0)
            + (typeof this.honoraires(1, 'Bail369') === 'number' ? this.honoraires(1, 'Bail369') : 0)
            + (typeof this.frais_juridique(1, 'Bail369') === 'number' ? this.frais_juridique(1, 'Bail369') : 0)
        this.$store.commit('updateSortieCash369', sortieCash)

        // Sortie de cash cumulé (même valeur que total_general)
        let sortieCashCumule = 0
        sortieCashCumule = this.total_general(1, 'Bail369')
        this.$store.commit('updateSortieCashCumule369', sortieCashCumule)


        // Coût mensuel sur 3 ans
        let coutMensuel = 0
        coutMensuel = this.total_general(1, 'Bail369')
            + this.total_general(2, 'Bail369')
            + this.total_general(3, 'Bail369')
        coutMensuel = coutMensuel / 36
        this.$store.commit('updateCoutMensuel369', coutMensuel)

        // Cout du m2 charges comprises
        let coutM2CC = 0
        coutM2CC = coutMensuel*12/this.surface_recherchee
        this.$store.commit('updateCoutM2CC369', coutM2CC)
    }
  },
  mounted () {
        this.updateCoutReel()
  },
  watch: {
      loyer_annuel369: function () {
          this.updateCoutReel()
      },
      surface_recherchee: function () {
          this.updateCoutReel()
      },
      duree: function () {
          this.updateCoutReel()
      },
      depot_garantie369: function () {
          this.updateCoutReel()
      },
      frais_agence: function () {
          this.updateCoutReel()
      },
      franchise_loyer369: function () {
          this.updateCoutReel()
      },
      charges_locatives_index: function () {
          this.updateCoutReel()
      },
      taxes_foncieres_index: function () {
          this.updateCoutReel()
      },
      frais_gestion_rate: function () {
          this.updateCoutReel()
      },
  },
  updated () {
  }
};
</script>